module.exports = __webpack_public_path__ + "massage-model-e9baad.webp";